import { Address } from "./address.model";
import { Communication } from "./communication.model";

export class Contact {
    /** Unique internal identity of the contact. */
    public id: number;

    /** A comma separated list of roles for the contact. */
    public roles: string;

    /** If the contact is an idnvidual this will hold the title (Mr. Mrs. Dr.), if any. */
    public title: string;

    /** First name of the contact. */
    public firstName: string;

    /** Optional middle name of the contact. */
    public middleName: string;
    
    /** Last name of the contact. */
    public lastName: string;

    /** If the contact is an idnvidual this will hold the suffix (II, III, DDS), if any. */
    public suffix: string;

    /** Company name of the contact, for those that are not individuals. */
    public companyName: string;

    /** Full name of the contact. */
    public name: string;

    /** Primary email address of the contact. */
    public email: string;

    /** Primary phone (cell) of the contact. */
    public phone: string;

    /** Primary web site of the business (typically) contact. */
    public website: string;

    /** Primary email address or website (if company) of the contact. */
    public comms: string;

    /** A list of addresses associated with the contact. */
    public contactCommunications: Communication[];

    /** Day of birth for the contact (individuals). */
    public birthdate: Date;

    /** Social security number or tax identifier (company) of the contact. */
    public taxPayerNumber: string;

    /** A list of addresses associated with the contact. */
    public contactAddresses: Address[];

    /** Primary residence or place of business city of the contact. */
    public city: string;

    /** Primary residence or place of business state of the contact. */
    public state: string;

    /** Primary residence or place of business postal (zip) code of the contact. */
    public zipCode: string;

    /** Indicates whether or not the contact is an individual (true) or company (false). */
    public isIndividual: boolean;

    /** Indicates whether or not the contact is a primary contact. */
    public primaryContact: boolean;

    /** Date and time the contact was created. */
    public createdAt: Date;

    /** Date and time the contact was modified. */
    public updatedAt: Date;
}